import { palette } from "@dev/ee-components";
import styled from "styled-components";
export const WidgetBoxWrapper = styled.div<{ $widgetIndex: number }>`
    grid-column: ${({ $widgetIndex }) => {
        if ($widgetIndex === -1) return 'span 12';
        if ($widgetIndex === 0) return 'span 5';
        if ($widgetIndex === 1) return 'span 7';
        
        if ($widgetIndex === 2) return 'span 7';
        if ($widgetIndex === 3) return 'span 5';
        
        const row = Math.floor($widgetIndex / 2);
        return row % 2 === 0 ? ($widgetIndex % 2 === 0 ? 'span 5' : 'span 7') : ($widgetIndex % 2 === 0 ? 'span 7' : 'span 5');
    }};
`;
export const WidgetBox = styled.div`
    height: 100%;
    background: white;
    border: 1px solid ${palette.gray[3]};
    border-radius: 4px;
    display: flex;
    flex-direction: column;
`;
export const WidgetTitle = styled.div<{ $isSelectVisible?: boolean }>`
    border-bottom: 1px solid ${palette.gray[3]};
    padding:  ${({$isSelectVisible}) => ($isSelectVisible ? '20px 32px 12px 32px' : '24px 32px 16px 32px')};
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
`;
export const WidgetContent = styled.div<{isContactsGrowth?: boolean}>`
    padding: ${({isContactsGrowth}) => (isContactsGrowth ? '16px 0 0' : '16px 32px')};
    justify-content: center;
    align-items: center;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
`;
export const WidgetButton = styled.div`
    border-top: 1px solid ${palette.gray[3]};
    padding: 24px 32px;
`;
